import { useEffect } from "react";

const setMeta = (name, content) => {
  let el = document.querySelector(`meta[name="${name}"]`);

  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }

  el.setAttribute("content", content);
};

export default function usePageMeta(title, description, keywords) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) setMeta("description", description);
    if (keywords) setMeta("keywords", keywords);
  }, [title, description, keywords]);
}